import React, { useState } from 'react';
import Modal from '../components/Modal';
import ConfirmModal from '../components/ConfirmModal';
import { AlertTriangle } from 'lucide-react';

const TestModal = () => {
  const [showBasicModal, setShowBasicModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const handleConfirm = () => {
    console.log('Modal funcionando!');
    setShowConfirmModal(false);
  };

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-6">Teste de Modais</h1>
      
      <div className="space-y-4">
        <button
          onClick={() => setShowBasicModal(true)}
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
        >
          Abrir Modal Básico
        </button>
        
        <button
          onClick={() => setShowConfirmModal(true)}
          className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 ml-4"
        >
          Abrir Modal de Confirmação
        </button>
      </div>

      {/* Modal Básico */}
      <Modal
        isOpen={showBasicModal}
        onClose={() => setShowBasicModal(false)}
        title="Teste Modal Básico"
      >
        <p>Este é um teste do modal básico. Se você consegue ver isso, o modal está funcionando!</p>
        <div className="mt-4 flex justify-end">
          <button
            onClick={() => setShowBasicModal(false)}
            className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
          >
            Fechar
          </button>
        </div>
      </Modal>

      {/* Modal de Confirmação */}
      <ConfirmModal
        isOpen={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        onConfirm={handleConfirm}
        title="Teste Modal de Confirmação"
        message="Este é um teste do modal de confirmação. Se você consegue ver isso, o modal está funcionando!"
        confirmText="Confirmar"
        cancelText="Cancelar"
        confirmVariant="danger"
        icon={AlertTriangle}
      />
    </div>
  );
};

export default TestModal;